// extracted by mini-css-extract-plugin
module.exports = {"label":"CreateDrawer_label__igeSs","customRadio":"CreateDrawer_customRadio__s6Xj4","card":"CreateDrawer_card__lMUzx"};